import flatpickr from "flatpickr"
import 'flatpickr/dist/flatpickr.min.css'
import Emitter from '@resources/js/helpers/Emitter'
import { addDay } from "@formkit/tempo"
import { isMobile } from '@resources/js/helpers/media'
import {getArrowRightHtml, getArrowLeftHtml} from './calendarTemplates'


export default class FlatpickrAdapter extends Emitter {
    #instance = null
    #config = {}

    constructor(element, config = {}) {
        super()

        this.#config = {
            static: true,
            position: isMobile() ? 'auto center' : 'left',
            defaultDate: [addDay(new Date(), 1), addDay(new Date(), 2)],
            mode: "range",
            dateFormat: "F j, Y",
            showMonths: isMobile() ? 1 : 2,
            minDate: "today",
            monthSelectorType: 'static',
            nextArrow: getArrowRightHtml(),
            prevArrow: getArrowLeftHtml(),
            clickOpens: false,
            onChange: (selectedDates) => {
                this.emit('change', selectedDates)
            },
            ...config
        }

        this.#instance = flatpickr(element, this.#config)
    }

    open() {
        this.#instance.open()
    }

    close() {
        this.#instance.close()
    }

    toggle() {
        this.#instance.toggle()
    }

    setDates(datesArray) {
        this.#instance.setDate(datesArray)
    }

    getDates() {
        return this.#instance.selectedDates
    }

    destroy() {
        this.#instance.destroy()
        this.#instance = null
    }

    isInitialized() {
        return this.#instance !== null
    }
}
